module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Articles Containing Laptop","linkToAmazon":"Link to Amazon","linkToLaptop":"Go to Laptop","loading":"Loading"}}')
  delete Component.options._Ctor
}
